import { NgTemplateOutlet } from '@angular/common';
import { Component, EventEmitter, Output, Input } from '@angular/core';
// import { MatIcon } from '@angular/material/icon';

export enum DatePickerHeaderType {
    RIGHT_DEFAULT = 'rightDefault',
    RIGHT_DROPDOWN = 'rightDropdown',
    CENTER_DEFAULT = 'centerDefault',
    CENTER_DROPDOWN = 'centerDropdown',
    OTHER = 'test'
}

export interface DianDropDownEvent {
    view: 'monthView' | 'yearView';
    state: boolean;
}

@Component({
  selector: 'dian-date-picker-header',
  standalone: true,
  imports: [NgTemplateOutlet],
  templateUrl: './date-picker-header.component.html',
  styleUrl: './date-picker-header.component.scss'
})
export class DatePickerHeaderComponent {
    @Input() currentMonth = '';
    @Input() currentYear = '';
    @Input() type: DatePickerHeaderType = DatePickerHeaderType.CENTER_DEFAULT

    @Output() prevMonth = new EventEmitter<boolean>();
    @Output() nextMonth = new EventEmitter<boolean>();
    @Output() dropDownToggle = new EventEmitter<'monthView' | 'yearView'>();

    datePickerHeaderType = DatePickerHeaderType;

    helpMessageOptions = Object.values(DatePickerHeaderType).join(' - ');

}
